import React, { Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CreateProductForm from "../../Components/Forms/CreateProductForm";
import styles from "../MainPages.module.css";

const AddProduct = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const navigate = useNavigate();

  return (
    <Fragment>
      <section className={`${styles["cd-cardSection"]} ${styles["cd-bgGlass"]}`}>
        <div className={styles["cd-cardHeader"]} >
          <div>
            <button
              type="button"
              className={styles["cd-backBtn"]}
              onClick={() => navigate(-1)}
            >
              ← Go Back
            </button>
          </div>
        </div>
      </section>

      <CreateProductForm categoryId={categoryId ?? ""} />
    </Fragment>
  );
};

export default AddProduct;
